import axios from 'axios';
import { managementScope } from '../auth/management-context.mjs';

const instance = axios.create({ baseURL: managementScope.apiBase, timeout: 15000 });
let csrfRequest = null;

instance.interceptors.request.use(async (config) => {
    config.managementSnapshot = managementScope.capture();
    config.baseURL = managementScope.apiBase;
    managementScope.assertCurrent(config.managementSnapshot);
    delete config.headers.Authorization;
    delete config.headers.authorization;
    if (!['get', 'head', 'options'].includes((config.method || 'get').toLowerCase())) {
        if (!csrfRequest) {
            csrfRequest = instance.get('/auth/csrf/').finally(() => { csrfRequest = null; });
        }
        const response = await csrfRequest;
        config.headers['X-CSRFToken'] = response.data.csrfToken;
    }
    managementScope.assertCurrent(config.managementSnapshot);
    return config;
});

instance.interceptors.response.use(response => {
    managementScope.assertCurrent(response.config.managementSnapshot);
    return response;
}, error => {
    if (error.config?.managementSnapshot) managementScope.assertCurrent(error.config.managementSnapshot);
    if (error.response?.status === 401 && !error.config?.url?.startsWith('/auth/')) {
        window.dispatchEvent(new Event('admin-session-expired'));
    }
    return Promise.reject(error);
});

export default instance;
